import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let { token, useBearer } = this.getAuthToken(request.url);

    // Clone the request with the appropriate Authorization header
    const authReq = request.clone({
      headers: token ? request.headers.set('Authorization', useBearer ? `Bearer ${token}` : token) : request.headers
    });

    return next.handle(authReq);
  }

  getAuthToken(url: string): { token: string, useBearer: boolean } {
        return { token: localStorage.getItem('token') || '', useBearer: true }; // Use "Bearer" for other URLs
  }
}
